import {
  DirectoryToIntegrationConfig,
  IntegrationConfig,
} from "@p0security/shared/integrations/shared";
import { directoryInfo } from "@p0security/shared/types/workflow/constants";
import { Directory } from "@p0security/shared/types/workflow/types";
import { widetype } from "@p0security/shared/util/collections";
import { reduce } from "lodash";
import { createContext, useEffect, useMemo } from "react";
import { useDirectoriesStore } from "store/resources/directoriesStore";

import { useFirestoreCollection } from "./FirestoreProvider";

type ResourcesStore = {
  directoryIntegrations: DirectoryToIntegrationConfig | null;
};

export const Resources = createContext<ResourcesStore>({
  directoryIntegrations: null,
});

export const ResourcesProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { setAvailableDirectories } = useDirectoriesStore();

  const { docs: integrations } = useFirestoreCollection<IntegrationConfig>(
    "integrations",
    {
      live: true,
      tenantAware: true,
    }
  );

  const directoryIntegrations = useMemo(() => {
    if (!integrations) return null;
    return reduce(
      integrations ?? [],
      (acc, i) => {
        acc[i.id as Directory] = i.data;
        return acc;
      },
      {} as DirectoryToIntegrationConfig
    );
  }, [integrations]);

  useEffect(() => {
    if (integrations) {
      setAvailableDirectories(
        widetype.keys(directoryInfo).filter((key) => {
          const config = integrations.find((i) => i.id === key);
          return config && directoryInfo[key].isInstalled(config.data);
        })
      );
    }
  }, [integrations, setAvailableDirectories]);

  return (
    <Resources.Provider
      value={{
        directoryIntegrations,
      }}
    >
      {children}
    </Resources.Provider>
  );
};
